export function headerHeight() {
    if(window.innerWidth > 1199) {
        function setPadding() {
            const wrapper = document.querySelector(".wrapper");
            const headerHeight = document.querySelector(".main-header").clientHeight;
            wrapper.style.paddingTop = headerHeight + "px";
        }

        setPadding();
        
        window.addEventListener("resize", () => {
            setTimeout(()=> {
                setPadding();
            }, 500);
        });
        
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerHeight.js